var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w2p-portal',{attrs:{"to":"notifications"}},[_c('product-not-printable-notification',{staticClass:"product-not-printable-notification",attrs:{"data":_vm.productIsPrintable}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }